import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

const ROLE_LEVEL: Record<string, number> = { USER: 1, AGENT: 2, ADMIN: 3 };

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;   // 정확히 해당 역할만 (기존)
  minRole?: string;        // 해당 역할 이상 (USER < AGENT < ADMIN)
}

export default function ProtectedRoute({ children, requiredRole, minRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  if (minRole) {
    const required = ROLE_LEVEL[minRole] ?? 0;
    const current = ROLE_LEVEL[user?.role || ''] ?? 0;
    if (current < required) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
